import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { useAppSelector } from "../../../../../redux";
import { FlexRowCenter } from "../../../../Common/Styles";
import { FollowersLoading } from "./Loading";

export const EmptySearchResult = () => {
  const { typography } = useTheme();
  const { searchUsers_API_STATUS } = useAppSelector(
    (state) => state.connections
  );

  if (searchUsers_API_STATUS === "progress") return <FollowersLoading />;

  return (
    <Container>
      <Components.Text
        style={{ tokenStyle: typography.Body.M }}
        letterSpacing="letter-spacing-100"
        text="No results found"
      />
    </Container>
  );
};

const Container = styled(FlexRowCenter)`
  padding: ${({ theme }) => theme.spacing["spacing-6"].value}rem 0;
`;
